export function HandSvg({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 416 416"
    >
      <g>
        <g>
          <path
            d="M208.014,8c-17.146,0-29.527,14.608-37.992,34.235c5.202,0.903,10.502,2.05,15.934,3.55
           c6.153-13.145,13.76-21.844,22.044-21.844c6.946,0.002,15.326,8.05,22.357,22.389c4.797-1.252,11.092-2.822,15.739-3.88
           C236.481,21.254,222.992,8.003,208.014,8z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M259.009,91.796c-1.147-9.262-2.806-18.029-4.968-26.196c5.322-0.855,10.499-1.446,15.229-1.446
           c11.811,0,19.405,2.786,22.578,8.297c3.475,6.019,0.294,17.504-8.205,30.209c3.899,3.791,7.672,7.714,11.205,11.813
           c13.541-18.89,18.306-37.12,10.857-50.022c-6.807-11.82-20.341-16.297-36.434-16.297c-18.981,0-41.458,6.25-60.75,13.994
           c-21.747-9.206-42.651-14.014-59.79-14.014c-18.169,0-32.125,5.313-38.436,16.238c-7.445,12.878-2.771,31.066,10.674,49.928
           c3.383-4.042,7.131-8.052,11.159-12.016c-8.333-12.586-11.432-23.934-7.978-29.908c2.982-5.161,12.17-8.242,24.582-8.242
           c4.243,0,8.822,0.45,13.54,1.126c-2.223,8.592-3.879,17.409-5.047,25.919c-38.692,29.289-59.2,64.821-46.97,86.017
           c6.81,11.81,20.341,16.286,36.429,16.286c4.017,0,8.224-0.363,12.491-0.877c-1.866-4.946-3.55-10.166-5.014-15.658
           c-2.528,0.225-5.118,0.534-7.477,0.534c-11.808,0-19.402-2.785-22.571-8.282c-3.973-6.884,0.321-20.706,12.734-36.551
           c6.014,6.014,12.753,11.915,20.246,17.61c6.226,47.126,26.6,81.742,50.838,81.742c0,0,0.018,0,0.027,0
           c18.832,0,31.89-17.623,40.34-40.181c6.676,1.112,13.031,1.683,18.935,1.683c18.167,0,32.121-5.313,38.428-16.236
           C320.651,151.364,289.661,115.655,259.009,91.796z M147.543,120.623c2.397-2.41,4.942-4.831,7.687-7.262
           c-0.086,2.289-0.134,4.508-0.135,6.622c-0.001,2.706,0.1,5.358,0.187,8.015C152.553,125.563,150.002,123.111,147.543,120.623z
            M260.638,113.967c2.542,2.266,5.03,4.611,7.47,7.028c-2.39,2.4-4.86,4.767-7.502,7.117c0.127-2.775,0.256-5.562,0.258-8.092
           C260.864,117.959,260.69,115.999,260.638,113.967z M238.59,68.863c0.872,3.238,1.682,6.605,2.399,10.143
           c-2.249-1.429-4.442-2.764-6.55-3.982c-1.959-1.132-3.922-2.129-5.883-3.191C231.895,70.75,235.25,69.758,238.59,68.863z
            M178.041,68.508c3.289,0.878,6.623,1.88,10.002,3.006c-2.248,1.173-4.503,2.349-6.491,3.496c-2.05,1.183-4.004,2.425-5.99,3.648
           C176.297,75.169,177.147,71.832,178.041,68.508z M175.433,162.788c2.046,1.265,3.977,2.594,6.091,3.816
           c1.914,1.106,3.832,2.079,5.749,3.12c-3.168,1.019-6.301,1.905-9.471,2.755C176.932,169.341,176.141,166.114,175.433,162.788z
            M207.93,216.058c-7.274,0-16.071-9.072-22.958-23.675c-0.699-1.482-1.332-3.089-1.983-4.662c8.38-2.318,16.674-5.12,24.45-8.238
           c8.579,3.634,16.996,6.545,25.13,8.768C226.037,204.712,217.426,216.058,207.93,216.058z M291.804,169.266
           c-2.978,5.158-12.163,8.236-24.572,8.236c-21.838,0-50.886-9.253-77.702-24.751c-6.097-3.523-11.853-7.377-17.419-11.35
           c-0.694-6.999-1.076-14.169-1.073-21.412c0.002-6.564,0.506-13.32,1.218-20.077c5.338-3.762,11.088-7.464,17.29-11.043
           c5.506-3.175,11.894-6.35,18.731-9.329c6.093,2.799,12.182,5.886,18.158,9.338c5.071,2.93,11.18,6.919,17.626,11.652
           c0.545,6.199,0.862,12.682,0.86,19.483c-0.003,7.047-0.477,14.324-1.299,21.575c-5.506,3.912-11.194,7.706-17.214,11.178
           c-2.806,1.618-5.858,3.234-9.059,4.829c6.847,2.874,13.61,5.262,20.175,7.131c0.871-0.52,1.651-1.09,2.51-1.617
           c-0.16,0.729-0.281,1.488-0.448,2.211c5.398,1.455,10.594,2.508,15.57,3.2c1.361-6.025,2.378-12.046,3.242-17.983
           c7.597-5.742,14.466-11.691,20.557-17.762C285.696,141.047,298.019,158.527,291.804,169.266z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="207.952" cy="120" r="16" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M388.656,72c-14.096,0-25.792,10.56-27.2,24.576l-10.128,100.016c-4.88,1.04-9.36,3.408-12.832,6.88l-80.816,75.232
           c-11.12,10.128-17.568,24.576-17.68,39.68V408h96v-42.176c0-6.512,2.736-12.848,7.696-17.552l60.72-61.28
           C411.888,279.44,416,269.44,416,258.832V99.344C416,84.272,403.728,72,388.656,72z M400,258.832c0,6.368-2.464,12.368-6.96,16.912
           l-60.528,61.088c-7.952,7.52-12.512,18.08-12.512,28.992V392h-64v-73.52c0.08-10.608,4.608-20.768,12.528-27.968l81.072-75.504
           c2.176-2.176,5.152-3.248,8.304-2.928c1.744,0.16,4.256,0.784,6.4,2.928c1.968,1.968,3.056,4.592,3.056,7.36
           s-1.104,5.392-2.784,7.088l-62.416,56.608l10.752,11.84l62.704-56.88c4.992-4.992,7.744-11.616,7.744-18.672
           c0-7.056-2.736-13.68-7.728-18.656c-2.432-2.464-5.264-4.352-8.368-5.648l10.096-99.84C377.952,92.384,382.816,88,388.656,88
           C394.912,88,400,93.088,400,99.344V258.832z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M158.32,278.704l-80.816-75.232c-3.472-3.472-7.952-5.856-12.832-6.88L54.544,96.576C53.136,82.56,41.44,72,27.344,72
           C12.272,72,0,84.272,0,99.344v159.488c0,10.608,4.112,20.608,11.584,28.144l60.72,61.28C77.264,352.96,80,359.312,80,365.824V408
           h96v-89.616C175.904,303.28,169.44,288.848,158.32,278.704z M160,392H96v-26.176c0-10.896-4.56-21.472-12.512-28.992
           L22.96,275.744C18.464,271.2,16,265.2,16,258.832V99.344C16,93.088,21.088,88,27.344,88c5.84,0,10.704,4.384,11.296,10.176
           l10.096,99.84c-3.104,1.312-5.936,3.2-8.368,5.648c-4.976,4.976-7.728,11.6-7.728,18.656c0,7.056,2.752,13.68,7.744,18.672
           l62.704,56.88l10.752-11.84l-62.416-56.608c-1.696-1.696-2.784-4.304-2.784-7.088s1.088-5.392,3.056-7.36
           c2.128-2.144,4.656-2.768,6.4-2.928c3.168-0.304,6.128,0.752,8.304,2.928l81.072,75.504c7.92,7.2,12.448,17.36,12.528,27.968V392z
           "
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export function Technician({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470 470"
    >
      <g>
        <path d="M208.958,228.542c63.01,0,114.271-51.262,114.271-114.271S271.968,0,208.958,0C145.949,0,94.688,51.262,94.688,114.271   S145.949,228.542,208.958,228.542z M208.958,15c54.738,0,99.271,44.533,99.271,99.271s-44.533,99.271-99.271,99.271   s-99.271-44.533-99.271-99.271S154.22,15,208.958,15z" />
        <path d="m296.701,341.928h-17.962c-4.142,0-7.5,3.357-7.5,7.5l-.001,15.248-54.779,74.872v-56.966l71.292-97.441c14.836,6.617 28.901,15.163 41.953,25.559 3.24,2.581 7.959,2.046 10.539-1.194 2.581-3.24 2.047-7.958-1.193-10.54-37.309-29.716-82.293-45.424-130.09-45.424-27.653,0-54.062,5.412-78.242,15.212-0.54,0.152-1.068,0.365-1.574,0.644-22.248,9.23-42.571,22.19-60.177,38.107-0.103,0.068-0.209,0.13-0.31,0.203-0.577,0.422-1.069,0.914-1.487,1.451-41.28,38.199-67.17,92.799-67.17,153.341 0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5c0-53.604 21.861-102.197 57.132-137.338l20.994,28.694c1.412,1.93 3.661,3.071 6.053,3.071h32.5v10.198c0,1.592 0.507,3.144 1.447,4.429l69.779,95.375c0.031,0.043 0.069,0.08 0.101,0.122 0.114,0.149 0.233,0.293 0.357,0.432 0.063,0.071 0.125,0.141 0.19,0.209 0.138,0.144 0.284,0.28 0.433,0.413 0.053,0.047 0.104,0.098 0.158,0.144 0.208,0.174 0.425,0.338 0.651,0.489 0.03,0.02 0.062,0.036 0.092,0.056 0.199,0.129 0.403,0.248 0.614,0.358 0.065,0.034 0.131,0.063 0.197,0.095 0.182,0.088 0.367,0.17 0.557,0.243 0.076,0.029 0.151,0.057 0.228,0.083 0.186,0.065 0.375,0.122 0.568,0.172 0.079,0.021 0.158,0.043 0.238,0.061 0.2,0.045 0.403,0.08 0.608,0.109 0.073,0.01 0.145,0.025 0.219,0.033 0.276,0.031 0.556,0.05 0.84,0.05s0.564-0.019 0.84-0.05c0.074-0.008 0.146-0.023 0.219-0.033 0.205-0.029 0.408-0.064 0.608-0.109 0.08-0.018 0.159-0.04 0.238-0.061 0.193-0.051 0.382-0.107 0.568-0.172 0.076-0.027 0.152-0.054 0.228-0.083 0.19-0.073 0.375-0.155 0.557-0.243 0.066-0.032 0.132-0.061 0.197-0.095 0.211-0.11 0.416-0.229 0.614-0.358 0.03-0.02 0.062-0.036 0.092-0.056 0.226-0.151 0.443-0.315 0.651-0.489 0.055-0.046 0.105-0.097 0.158-0.144 0.149-0.133 0.295-0.269 0.433-0.413 0.065-0.068 0.127-0.139 0.19-0.209 0.125-0.14 0.243-0.284 0.357-0.432 0.032-0.042 0.07-0.079 0.101-0.122l69.78-95.375c0.94-1.285 1.447-2.836 1.447-4.429v-10.198h10.462c4.143,0 7.5-3.358 7.5-7.5s-3.353-7.499-7.495-7.499zm-95.243,97.619l-54.78-74.873v-15.247c0-4.142-3.358-7.5-7.5-7.5h-36.194l-19.75-26.994c14.082-12.015 29.895-22.055 47.012-29.686l71.212,97.333v56.967zm7.5-72.118l-64.319-87.911c20.138-7.099 41.783-10.976 64.319-10.976 22.319,0 43.975,3.693 64.396,10.87l-64.396,88.017z" />
        <path d="m193.959,144.209c4.142,0 7.5-3.358 7.5-7.5 0-4.136 3.365-7.5 7.5-7.5 4.136,0 7.5,3.364 7.5,7.5 0,4.142 3.358,7.5 7.5,7.5h41.648c12.958,0 23.5-10.542 23.5-23.5v-23.249c0-12.958-10.542-23.5-23.5-23.5h-113.296c-12.958,0-23.5,10.542-23.5,23.5v23.249c0,12.958 10.542,23.5 23.5,23.5h41.648zm-50.148-23.5v-23.249c0-4.687 3.813-8.5 8.5-8.5h113.296c4.687,0 8.5,3.813 8.5,8.5v23.249c0,4.687-3.813,8.5-8.5,8.5h-35.433c-3.095-8.73-11.437-15-21.215-15s-18.12,6.27-21.215,15h-35.434c-4.686,0-8.499-3.813-8.499-8.5z" />
        <path d="m416.791,315.156v-79.114c0-4.142-3.357-7.5-7.5-7.5h-37.958c-4.143,0-7.5,3.358-7.5,7.5v79.114c-31.604,11.122-53.21,41.239-53.21,75.155 0,43.94 35.748,79.689 79.688,79.689 43.941,0 79.689-35.748 79.689-79.688 0-33.916-21.605-64.034-53.209-75.156zm-26.48,139.844c-33.131,0-60.509-25.042-64.24-57.189h76.429c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-76.432c3.035-25.931 21.599-47.934 47.231-54.904 3.266-0.888 5.532-3.853 5.532-7.237v-77.128h22.958v77.128c0,3.384 2.267,6.349 5.532,7.237 25.632,6.97 44.196,28.973 47.231,54.904h-22.052c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h22.051c-3.73,32.148-31.108,57.189-64.24,57.189z" />
      </g>
    </svg>
  );
}

export function Microscope({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      width="100%"
      height={height}
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470 470"
    >
      <g>
        <path d="m146.897,250.626h9.594v33.668c0,4.142 3.358,7.5 7.5,7.5h30.2c4.142,0 7.5-3.358 7.5-7.5v-33.668h15v33.668c0,4.142 3.358,7.5 7.5,7.5h30.201c4.142,0 7.5-3.358 7.5-7.5v-33.668h9.594c4.142,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-4.493v-104.88h20.507l65.471,37.313c12.151,6.991 22.417,24.742 22.417,38.761v50.724c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-50.724c0-19.367-13.15-42.104-29.963-51.778l-67.224-38.312c-1.131-0.645-2.411-0.984-3.713-0.984h-22.496v-38.349c0-4.142-3.358-7.5-7.5-7.5h-12.634v-62.397c0-4.142-3.358-7.5-7.5-7.5h-60.334c-4.142,0-7.5,3.358-7.5,7.5v62.397h-12.634c-4.142,0-7.5,3.358-7.5,7.5v158.229h-4.493c-4.142,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5zm39.793,26.168h-15.2v-26.168h15.2v26.168zm60.201,0h-15.201v-26.168h15.201v26.168zm-60.368-261.794h45.334v54.897h-45.334v-54.897zm-20.133,69.897h85.602v150.729h-85.602v-150.729z" />
        <path d="m382.888,280.044c-20.898,0-37.901,17.002-37.901,37.901 0,18.332 13.083,33.662 30.401,37.153v99.902h-307.3l18.392-42.877c5.354-12.482 21.353-23.027 34.934-23.027h231.073c4.142,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-22.5v-162.544c0-2.7-1.452-5.192-3.801-6.524l-32.997-18.709c-3.604-2.042-8.18-0.778-10.224,2.825-2.043,3.603-0.778,8.18 2.825,10.224l29.196,16.554v94.524h-168.089c-4.142,0-7.5,3.358-7.5,7.5v30c0,4.142 3.358,7.5 7.5,7.5h145.591c4.142,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-138.091v-15h160.591v48.651h-193.573c-19.594,0-40.994,14.106-48.719,32.114l-22.877,53.333c-0.994,2.317-0.757,4.979 0.631,7.084 1.388,2.105 3.74,3.372 6.262,3.372h326.178c4.142,0 7.5-3.358 7.5-7.5v-107.402c17.318-3.491 30.401-18.821 30.401-37.153-0.001-20.898-17.004-37.901-37.903-37.901zm0,60.803c-12.627,0-22.901-10.273-22.901-22.901 0-12.627 10.273-22.901 22.901-22.901 12.628,0 22.901,10.273 22.901,22.901 0.001,12.627-10.273,22.901-22.901,22.901z" />
      </g>
    </svg>
  );
}
export function Graph({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <rect
        x="84.426"
        y="239.66"
        style={{ fill: "none" }}
        width="85.33"
        height="231.489"
      />
      <rect
        x="169.755"
        y="316.819"
        style={{ fill: "none" }}
        width="80.798"
        height="154.33"
      />
      <rect
        x="294.128"
        y="85.33"
        style={{ fill: "none" }}
        width="80.798"
        height="385.819"
      />
      <rect
        x="374.926"
        y="162.5"
        style={{ fill: "none" }}
        width="85.33"
        height="308.649"
      />
      <g>
        <path
          d="M503.83,462.979H49.021V8.17c0-4.512-3.657-8.17-8.17-8.17s-8.17,3.658-8.17,8.17v68.993H8.17
		c-4.513,0-8.17,3.658-8.17,8.17c0,4.512,3.657,8.17,8.17,8.17h24.511v60.822H8.17c-4.513,0-8.17,3.658-8.17,8.17
		c0,4.512,3.657,8.17,8.17,8.17h24.511v60.823H8.17c-4.513,0-8.17,3.658-8.17,8.17c0,4.512,3.657,8.17,8.17,8.17h24.511v60.822H8.17
		c-4.513,0-8.17,3.658-8.17,8.17c0,4.512,3.657,8.17,8.17,8.17h24.511v60.822H8.17c-4.513,0-8.17,3.658-8.17,8.17
		c0,4.512,3.657,8.17,8.17,8.17h24.511v68.994c0,4.512,3.657,8.17,8.17,8.17h120.737v24.511c0,4.512,3.657,8.17,8.17,8.17
		c4.513,0,8.17-3.658,8.17-8.17v-24.511h188.823v24.511c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17v-24.511H503.83
		c4.513,0,8.17-3.658,8.17-8.17C512,466.637,508.343,462.979,503.83,462.979z"
        />
        <path
          d="M84.426,446.638c4.513,0,8.17-3.658,8.17-8.17V247.83h68.993v190.638c0,4.512,3.657,8.17,8.17,8.17
		c4.513,0,8.17-3.658,8.17-8.17V324.993h64.454v113.476c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17V316.822
		c0-4.512-3.657-8.17-8.17-8.17h-72.624V239.66c0-4.512-3.657-8.17-8.17-8.17H84.426c-4.513,0-8.17,3.658-8.17,8.17v198.809
		C76.255,442.98,79.912,446.638,84.426,446.638z"
        />
        <path
          d="M294.128,446.638c4.513,0,8.17-3.658,8.17-8.17V93.503h64.454v344.965c0,4.512,3.657,8.17,8.17,8.17
		c4.513,0,8.17-3.658,8.17-8.17V170.667h68.993v267.801c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17V162.497
		c0-4.512-3.657-8.17-8.17-8.17h-77.163V85.333c0-4.512-3.657-8.17-8.17-8.17h-80.795c-4.513,0-8.17,3.658-8.17,8.17v353.135
		C285.957,442.98,289.614,446.638,294.128,446.638z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Globe({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 464 464"
    >
      <g>
        <g>
          <path d="M32,0c0,18.383-13.614,32-32,32c18.386,0,32,13.614,32,32c0-18.386,13.614-32,32-32C45.614,32,32,18.383,32,0z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M416,368c0,27.578-20.422,48-48,48c27.578,0,48,20.422,48,48c0-27.578,20.422-48,48-48C436.422,416,416,395.578,416,368z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M390.383,97.367C388.422,96.508,386.275,96,384,96c-8.828,0-16,7.18-16,16c0,2.274,0.508,4.418,1.367,6.379
           C371.84,124.023,377.45,128,384,128c8.828,0,16-7.18,16-16C400,105.453,396.03,99.84,390.383,97.367z M384,120
           c-3.924,0-7.05-2.898-7.722-6.637C376.195,112.902,376,112.484,376,112c0-4.414,3.594-8,8-8c0.484,0,0.902,0.191,1.363,0.274
           C389.098,104.946,392,108.07,392,112C392,116.414,388.406,120,384,120z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M368,32c-20.504,0-38.549,9.817-50.262,24.813C289.978,41.145,258.086,32,224,32C118.131,32,32,118.129,32,224
           c0,105.867,86.131,192,192,192c134.752,0,230.486-137.324,176.91-265.371C456.614,116.988,432.326,32,368,32z M324.701,75.422
           C322.348,86.691,328.748,100,344,100c11.031,0,20-8.969,20-20s-8.969-20-20-20c-4.254,0-7.744,1.114-10.629,2.848
           C342.114,53.718,354.39,48,368,48c10.504,0,20.201,3.43,28.114,9.176C393.682,58.516,392,61.019,392,64
           c0,4.137,3.182,7.426,7.211,7.84C399.482,71.867,399.718,72,400,72c3.47,0,5.656-1.782,6.848-4.078
           C412.578,75.828,416,85.512,416,96c0,26.465-21.531,48-48,48c-6.198,0-12.106-1.222-17.549-3.367
           C353.561,135.946,351.49,128,344,128c-3.668,0-5.981,1.973-7.103,4.488C326.574,123.68,320,110.602,320,96
           C320,88.629,321.718,81.668,324.701,75.422z M332,80c0-6.617,5.39-12,12-12c6.61,0,12,5.383,12,12s-5.39,12-12,12
           C337.39,92,332,86.617,332,80z M96,103.574C128.121,69.453,173.55,48,224,48c31.026,0,60.062,8.27,85.375,22.453
           c-1.332,3.047-2.266,6.278-3.114,9.547H255.93C231.32,80,208,96.562,208,128.187v18.336c0,15.078,19.381,24.637,32,12.586
           c0,6.664,0.414,11.492-5.379,15.93c-9.039,6.926-19.11,17.282-18.348,34.102c-6.327-1.777-9.769-1.14-40.743-1.14
           c-13.932,0-25.783,9.082-29.939,21.855C132.11,194.18,96,201.832,96,160.961V103.574z M48,224c0-37.531,11.906-72.278,32-100.875
           v37.836c0,51.703,41.645,45.215,51.535,77.207c6.889,22.293,23.313,40.43,44.465,49.715v16.18c32.258,59.863,32,54.058,32,79.938
           c0,8.309,6.359,15.058,14.463,15.844C133.824,398.114,48,330.562,48,224z M192,300.027V288h45.614
           c14.354,0,23.574,13.535,15.367,25.363c-12.894,19.336-2.466,32.039-13.645,47.43l-15.328,21.55
           C223.974,354.137,221.746,355.23,192,300.027z M226.252,399.793c8.252-1.004,11.45-8,26.362-29.574l-0.332-0.023
           c6.61-9.102,9.474-20.305,9.129-31.809c-0.461-15.426,13.397-19.906,10.15-39.762C268.965,282.738,253.711,272,237.614,272
           c-24.106,0-20.902,0-45.614,0c-22.918-13.183-31.725-21.91-32-32.473c0-8.574,6.953-15.527,15.53-15.527
           c33.518,0,40.959-3.121,49.721,12.035c1.359,2.351,3.835,3.965,6.75,3.965c4.418,0,8-3.582,8-8c0-1.414-0.469-2.668-1.106-3.82
           c-22.334-40.348,17.106-33,17.106-64.051c0-8,0.801-15.859-10.414-20.512c-5.453-2.258-11.726-1.008-15.902,3.164
           c-0.904,0.902-1.34,1.782-3.402,1.782c-0.875,0-2.282-1.301-2.282-2.039v-18.84C224,108.988,239.797,96,255.826,96H304
           c0,41.34,39.504,73.91,82.355,61.008c6.658,15.973,11.207,33.035,12.834,50.992H360c-46.851,0-55.262,67.34-9.645,78.621
           c11.951,2.953,0.598,17.305,16.238,37.969l0.89,0.977C331.076,376.844,278.383,399.707,226.252,399.793z M377.039,310.594
           c-2.588-4.801-4.328-10.106-4.328-15.957c-0.043-11.183-7.66-20.867-18.516-23.547C326.75,264.301,332.023,224,360,224h40
           C400,255.484,391.582,284.996,377.039,310.594z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Compass({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470.002 470.002"
    >
      <path d="m383.646,396.844l-2.738-8.032c1.459-3.526 2.269-7.386 2.269-11.433 0-11.089-6.053-20.785-15.024-25.978l-44.793-131.383h32.019v2.5c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-20c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v2.5h-37.133l-38.263-112.23c-0.173-0.506-0.401-0.986-0.672-1.438 0.295-2.083 0.452-4.203 0.452-6.35 0-22.257-16.246-40.781-37.5-44.363v-33.137c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v33.137c-21.254,3.582-37.5,22.106-37.5,44.363 0,2.71 0.246,5.378 0.713,7.981l-38.197,112.036h-38.133v-2.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v20c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-2.5h33.019l-23.715,69.561c-1.337,3.921 0.758,8.183 4.678,9.519 0.802,0.273 1.618,0.403 2.421,0.403 3.121,0 6.035-1.963 7.098-5.082l61.86-181.444c3.152,3.972 6.985,7.425 11.38,10.173l-103.492,303.556c-2.61-2.133-4.743-4.826-6.142-7.921-2.411-5.332-2.526-11.264-0.323-16.703 0.053-0.13 0.102-0.262 0.147-0.395l26.889-78.87c1.337-3.921-0.758-8.183-4.678-9.519-3.921-1.335-8.183,0.759-9.519,4.678l-11.275,33.07c-9.615,5.207-15.664,15.177-15.664,26.334 0,4.185 0.883,8.305 2.559,12.104l-2.446,7.173c-3.672,9.223-3.446,19.267 0.642,28.307 3.115,6.889 8.325,12.652 14.774,16.51l-6.344,18.606c-1.337,3.921 0.758,8.183 4.678,9.519 0.802,0.273 1.618,0.403 2.421,0.403 3.121,0 6.035-1.963 7.098-5.082l20.959-61.475c9.315-5.288 15.177-15.163 15.177-26.067 0-3.992-0.806-7.939-2.336-11.595l49.696-145.766h33.553v12.5c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-12.5h33.554l49.695,145.762c-1.502,3.57-2.335,7.489-2.335,11.599 0,11.152 6.121,20.895 15.176,26.065l20.96,61.476c1.063,3.119 3.977,5.082 7.098,5.082 0.802,0 1.619-0.13 2.421-0.403 3.92-1.336 6.015-5.598 4.678-9.519l-6.339-18.593c15.018-8.917 22.317-27.509 16.477-44.639zm-45.47-19.465c0-8.271 6.729-15 15-15s15,6.729 15,15-6.729,15-15,15-15-6.729-15-15zm12.789-29.91c-5.216,0.382-10.065,2.101-14.206,4.819l-78.121-229.141c4.723-2.953 8.798-6.719 12.074-11.069l80.253,235.391zm-108.703-224.969c0,4.136-3.364,7.5-7.5,7.5s-7.5-3.364-7.5-7.5c0-0.513 0.052-1.014 0.151-1.498 0.705-3.428 3.732-6.002 7.349-6.002s6.645,2.574 7.346,5.987c0.102,0.499 0.154,1 0.154,1.513zm-7.5-67.5c16.542,0 30,13.458 30,30 0,9.597-4.557,18.417-12.012,24.001-4.109-5.462-10.643-9.001-17.988-9.001s-13.879,3.539-17.988,9.001c-7.455-5.584-12.012-14.403-12.012-24.001 0-16.542 13.458-30 30-30zm7.5,150.018v-12.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v12.5h-28.439l22.093-64.802c3.821,2.993 8.627,4.784 13.846,4.784 5.219,0 10.025-1.791 13.847-4.785l22.093,64.802h-28.44zm119.886,221.739l-6.64-19.477c5.206-0.402 10.043-2.135 14.17-4.864 2.751,9.056-0.483,18.661-7.53,24.341z" />
    </svg>
  );
}
export function Microscope2({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 480 480"
    >
      <g>
        <g>
          <circle cx="288" cy="376" r="12" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="304" cy="168" r="12" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M367.318,285.406c-0.543-4.234-1.698-8.302-2.95-12.328c-6.99-5.486-11.602-13.746-12.175-23.158
           c-4.585-6.013-9.849-11.592-16.194-16.288v14.362c0,20.815,13.325,38.364,31.85,45.021
           C367.767,290.482,367.645,287.948,367.318,285.406z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M432.016,104V72H336v31.654c8.1,4.057,15.383,9.586,21.424,16.346h58.592v57.552c5.81,6.07,11.169,12.457,16,19.217V120
           H448c0,58.068,0,82.426,0,103.915c8.14,17.478,13.322,36.354,15.141,56.085h0.788L464,120h16v-16
           C462.19,104,449.858,104,432.016,104z M416.016,104H352V88h64.016V104z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M95.992,296C122.506,296,144,274.506,144,247.992V120h16v-16h-16V72H47.984v32C29.334,104,16,104,0,104v16h16v208H0v16
           c77.742,0,88.446,0,160,0v-16H32V120h15.984v127.992C47.984,274.506,69.478,296,95.992,296z M63.984,88H128v16H63.984V88z
            M63.984,120H128v127.992C128,265.642,113.642,280,95.992,280s-32.008-14.358-32.008-32.008V120z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M444.545,328c2.866-13.857,4.102-28.298,3.065-43.229c-4.032-57.981-40.124-105.875-89.586-130.572
           c-6.174-24.182-27.918-42.143-54.024-42.143c0-13.586,0-22.811,0-23.964c-0.001-8.837-7.164-16.093-16-16.093h-16h-0.14V39.997
           h16.15V24H192v15.997h16v32.002l-16.001-0.001c-8.837,0.001-15.999,7.164-15.999,16c0,99.541,0,71.118,0,170.097
           c0,3.78,1.502,7.406,4.176,10.08l23.65,23.65c2.673,2.673,6.299,4.175,10.08,4.176h52.19c3.78-0.001,7.406-1.503,10.08-4.176
           l23.65-23.65c2.674-2.674,4.174-6.298,4.174-10.078c0-1.426,0-15.132,0-34.151c11.726,0,22.586-3.634,31.576-9.8
           c25.15,14.463,43.742,39.05,47.612,69.225c2.03,15.824-0.037,30.904-4.977,44.631h-57.727l15.999,16h34.306
           c-6.883,11.722-16.068,21.943-27.085,29.849l-38.579-38.58c-4.74-4.74-10.914-7.131-17.125-7.264L176,328v48h53.075l-16,16H176
           c-17.673,0-32,14.326-32,32v32h264h8v-16.341c0-27.561,7.254-54.313,18.423-79.508c2.319-5.233,4.289-10.646,6.045-16.151
           c14.548,0,24.426,0,39.532,0v-16H444.545z M256,39.999v32h-31.999L224,40L256,39.999z M288,257.37L265.372,280l-50.744-0.001
           l-22.627-22.627V248H288V257.37z M192,232l-0.001-144.001l96,0.092c0,1.392,0.001,14.422,0.001,26.568
           c-23.045,6.917-39.944,28.043-39.944,53.341s16.899,46.424,39.944,53.341L288.001,232H192z M304,207.944
           c-22.026,0-39.944-17.919-39.944-39.944s17.919-39.944,39.944-39.944c22.025,0,39.944,17.919,39.944,39.944
           S326.026,207.944,304,207.944z M192,360v-15.942h69.017L245.075,360H192z M400.001,440L400.001,440H160v-16
           c0-8.822,7.178-16,16-16c16.35,0,27.28,0,43.702,0c5.997-5.997,57.432-57.433,63.999-63.999h7.53
           c12.522,12.522,56.918,56.918,63.997,63.999c10.878,0,17.75,0,28.773,0c8.822,0,16,7.178,16,16V440z M419.796,353.667
           c-6.942,15.658-11.767,31.066-14.993,46.2C399.196,395.03,391.986,392,384,392h-22.145l-6.809-6.809
           c6.101-4.534,11.933-9.466,17.043-15.275c21.261-24.162,31.091-56.45,26.969-88.583c-4.274-33.318-23.866-61.499-51.302-78.862
           c6.559-8.313,10.722-18.453,11.698-29.61c40.458,23.507,68.837,64.752,72.194,113.021
           C433.285,309.429,429.298,332.235,419.796,353.667z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Molecular({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M384,313.472V286.52c9.288-3.312,16-12.112,16-22.528c0-13.232-10.768-24-24-24c-4.912,0-9.48,1.496-13.28,4.032
           l-27.912-20.936c0.704-2.248,1.192-4.6,1.192-7.088c0-10.416-6.712-19.216-16-22.528V166.52c9.288-3.312,16-12.112,16-22.528
           c0-13.232-10.768-24-24-24c-4.912,0-9.48,1.496-13.28,4.032l-27.912-20.936C271.512,100.84,272,98.488,272,96
           c0-13.232-10.768-24-24-24s-24,10.768-24,24c0,2.488,0.488,4.84,1.192,7.104L197.28,124.04c-3.8-2.544-8.368-4.04-13.28-4.04
           c-13.232,0-24,10.768-24,24c0,10.416,6.712,19.216,16,22.528v26.952c-9.288,3.312-16,12.112-16,22.528
           c0,2.488,0.488,4.84,1.192,7.104l-27.912,20.936c-3.8-2.552-8.368-4.048-13.28-4.048c-13.232,0-24,10.768-24,24
           c0,10.416,6.712,19.216,16,22.528v26.952c-9.288,3.312-16,12.112-16,22.528c0,13.232,10.768,24,24,24
           c4.912,0,9.48-1.496,13.288-4.04L160,376c0,13.232,10.768,24,24,24s24-10.768,24-24l26.72-20.04c3.8,2.544,8.368,4.04,13.28,4.04
           s9.48-1.496,13.28-4.032L288,376c0,13.232,10.768,24,24,24s24-10.768,24-24l26.712-20.04c3.808,2.544,8.376,4.04,13.288,4.04
           c13.232,0,24-10.768,24-24C400,325.584,393.288,316.784,384,313.472z M376,256c4.408,0,8,3.584,8,8c0,4.416-3.592,8-8,8
           c-4.408,0-8-3.584-8-8C368,259.584,371.592,256,376,256z M312,136c4.408,0,8,3.584,8,8s-3.592,8-8,8c-4.408,0-8-3.584-8-8
           S307.592,136,312,136z M320,216c0,4.416-3.592,8-8,8c-4.408,0-8-3.584-8-8s3.592-8,8-8C316.408,208,320,211.584,320,216z M248,88
           c4.408,0,8,3.584,8,8s-3.592,8-8,8c-4.408,0-8-3.584-8-8S243.592,88,248,88z M208,144c0-2.488-0.488-4.848-1.2-7.104
           l27.912-20.928C238.52,118.504,243.088,120,248,120s9.48-1.496,13.288-4.04l27.912,20.928c-0.712,2.264-1.2,4.624-1.2,7.112
           c0,10.416,6.712,19.216,16,22.528v26.952c-9.288,3.312-16,12.112-16,22.528c0,2.488,0.488,4.84,1.192,7.104l-27.912,20.936
           c-3.8-2.552-8.368-4.048-13.28-4.048s-9.48,1.496-13.288,4.04L206.8,223.104c0.712-2.264,1.2-4.616,1.2-7.104
           c0-10.416-6.712-19.216-16-22.528V166.52C201.288,163.216,208,154.416,208,144z M256,264c0,4.416-3.592,8-8,8s-8-3.584-8-8
           c0-4.416,3.592-8,8-8S256,259.584,256,264z M184,136c4.408,0,8,3.584,8,8s-3.592,8-8,8s-8-3.584-8-8S179.592,136,184,136z
            M184,208c4.408,0,8,3.584,8,8s-3.592,8-8,8s-8-3.584-8-8S179.592,208,184,208z M120,256c4.408,0,8,3.584,8,8c0,4.416-3.592,8-8,8
           s-8-3.584-8-8C112,259.584,115.592,256,120,256z M120,344c-4.408,0-8-3.584-8-8c0-4.416,3.592-8,8-8s8,3.584,8,8
           C128,340.416,124.408,344,120,344z M184,384c-4.408,0-8-3.584-8-8c0-4.416,3.592-8,8-8s8,3.584,8,8
           C192,380.416,188.408,384,184,384z M224,336c0,2.488,0.488,4.848,1.2,7.104l-23.088,17.32C197.704,355.312,191.264,352,184,352
           c-7.264,0-13.704,3.312-18.104,8.424l-23.088-17.32c0.704-2.256,1.192-4.616,1.192-7.104c0-10.416-6.712-19.216-16-22.528V286.52
           c9.288-3.312,16-12.112,16-22.528c0-2.488-0.488-4.848-1.2-7.104l27.912-20.928c3.808,2.544,8.376,4.04,13.288,4.04
           s9.48-1.496,13.288-4.04l27.904,20.936C224.488,259.16,224,261.512,224,264c0,10.416,6.712,19.216,16,22.528v26.952
           C230.712,316.784,224,325.584,224,336z M248,344c-4.408,0-8-3.584-8-8c0-4.416,3.592-8,8-8s8,3.584,8,8
           C256,340.416,252.408,344,248,344z M312,384c-4.408,0-8-3.584-8-8c0-4.416,3.592-8,8-8c4.408,0,8,3.584,8,8
           C320,380.416,316.408,384,312,384z M352,336c0,2.488,0.488,4.84,1.192,7.104l-23.088,17.32c-4.4-5.112-10.84-8.424-18.104-8.424
           c-7.264,0-13.704,3.312-18.104,8.424l-23.088-17.32c0.704-2.256,1.192-4.616,1.192-7.104c0-10.416-6.712-19.216-16-22.528V286.52
           c9.288-3.312,16-12.112,16-22.528c0-2.488-0.488-4.848-1.192-7.104l27.904-20.936C302.52,238.504,307.088,240,312,240
           s9.48-1.496,13.288-4.04l27.912,20.928c-0.712,2.264-1.2,4.624-1.2,7.112c0,10.416,6.712,19.216,16,22.528v26.952
           C358.712,316.784,352,325.584,352,336z M376,344c-4.408,0-8-3.584-8-8c0-4.416,3.592-8,8-8c4.408,0,8,3.584,8,8
           C384,340.416,380.408,344,376,344z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M472,0h-96c-13.232,0-24,10.768-24,24v64c0,13.232,10.768,24,24,24h40v36.688l-49.656,49.656l11.312,11.312L432,155.312
           V112h40c13.232,0,24-10.768,24-24V24C496,10.768,485.232,0,472,0z M480,88c0,4.416-3.592,8-8,8h-96c-4.408,0-8-3.584-8-8V24
           c0-4.416,3.592-8,8-8h96c4.408,0,8,3.584,8,8V88z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="384" y="32" width="80" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="384" y="64" width="48" height="16" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M171.312,48H144V24c0-13.232-10.768-24-24-24H24C10.768,0,0,10.768,0,24v64c0,13.232,10.768,24,24,24h96
           c13.232,0,24-10.768,24-24V64h20.688l29.656,29.656l11.312-11.312L171.312,48z M128,88c0,4.416-3.592,8-8,8H24
           c-4.408,0-8-3.584-8-8V24c0-4.416,3.592-8,8-8h96c4.408,0,8,3.584,8,8V88z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="32" y="32" width="80" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="32" y="64" width="48" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="32" y="416" width="80" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="32" y="448" width="48" height="16" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M274.344,402.344L244.688,432H144v-24c0-13.232-10.768-24-24-24H24c-13.232,0-24,10.768-24,24v64
           c0,13.232,10.768,24,24,24h96c13.232,0,24-10.768,24-24v-24h107.312l34.344-34.344L274.344,402.344z M128,472c0,4.416-3.592,8-8,8
           H24c-4.408,0-8-3.584-8-8v-64c0-4.416,3.592-8,8-8h96c4.408,0,8,3.584,8,8V472z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="416" y="376" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="416" y="424" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="440" y="400" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="392" y="400" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="136" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="184" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="120" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="72" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="464" y="216" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="432" y="296" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="352" y="384" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="448" y="64" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="64" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="64" y="248" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="96" y="448" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Scientific({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M456,56H168V40c0-22.056-17.944-40-40-40c-22.056,0-40,17.944-40,40v16H40C17.944,56,0,73.944,0,96v256
           c0,22.056,17.944,40,40,40h48v88H32v16h432v-16h-56v-88h48c22.056,0,40-17.944,40-40V96C496,73.944,478.056,56,456,56z M104,40
           c0-13.232,10.768-24,24-24s24,10.768,24,24v32h-48V40z M104,88h48v16h-48V88z M104,120h16v16h16v-16h16v136h-16V152h-16v104h-16
           V120z M145.056,272L128,297.576L110.944,272H145.056z M128,326.424l40-60V104h280v240H48V104h40v162.424L128,326.424z M136,480
           h-32v-88h32V480z M344,480H152v-88h192V480z M392,480h-32v-88h32V480z M480,352c0,13.232-10.768,24-24,24H40
           c-13.232,0-24-10.768-24-24V96c0-13.232,10.768-24,24-24h48v16H32v272h432V88H168V72h288c13.232,0,24,10.768,24,24V352z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M400,196v-32l-40-30l-32,24l-32-24l-40,30v32l-32,24v40l40,30l32-24l32,24l32-24l32,24l40-30v-40L400,196z M288,252
           l-24,18l-24-18v-24l24-18l24,18V252z M272,196v-24l24-18l24,18v24l-24,18L272,196z M352,252l-24,18l-24-18v-24l24-18l24,18V252z
            M336,196v-24l24-18l24,18v24l-24,18L336,196z M416,252l-24,18l-24-18v-24l24-18l24,18V252z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect y="480" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="480" y="480" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="392" y="304" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="344" y="304" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="304" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="248" y="304" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Suit({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M413.04,302.496l-6.088-3.656l4.616-8.072c4.28-7.496,1.744-17.2-5.664-21.656l-12.848-7.712l1.448-5.056
			C403.464,225.016,408,192.592,408,160C408,71.776,336.224,0,248,0S88,71.776,88,160c0,32.592,4.536,65.016,13.496,96.352
			l1.52,5.312L90.6,269.112c-7.408,4.456-9.936,14.168-5.656,21.656l4.488,7.848l-6.464,3.88C61.392,315.432,48,339.088,48,364.232
			V496h400V364.232C448,339.088,434.608,315.432,413.04,302.496z M397.68,282.832l-56.064,98.112l-26.28-15.768l56.056-98.112
			L397.68,282.832z M248,152c-28.616,0-38.736,19.584-39.16,20.424l-1.272,2.536l2.096,9.424
			c-24.48,2.768-44.192,21.376-48.672,45.304l-9.968-9.968c-4.528-4.536-7.024-10.56-7.024-16.976V120c0-13.232,10.768-24,24-24h160
			c13.232,0,24,10.768,24,24v82.744c0,6.416-2.496,12.448-7.024,16.976l-9.968,9.968c-4.48-23.928-24.2-42.528-48.672-45.304
			l2.096-9.424l-1.272-2.536C286.736,171.584,276.616,152,248,152z M271.448,177.592L257.584,240h-19.168l-13.864-62.392
			c2.76-3.368,9.72-9.608,23.448-9.608C261.768,168,268.736,174.28,271.448,177.592z M193.584,262.264L176,244.688V240
			c0-21.096,16.472-38.248,37.2-39.72l8.872,39.912c-10.544,0.856-19.184,8.464-21.448,18.552L193.584,262.264z M200,276.944v30.112
			l-26.144,13.072l-13.384-23.416L200,276.944z M282.8,200.28c20.728,1.472,37.2,18.624,37.2,39.72v4.688l-17.552,17.552
			l-7.072-3.512c-2.272-10.08-10.904-17.68-21.448-18.536L282.8,200.28z M296,276.888l40.024,19.84l-13.376,23.416L296,307.016
			V276.888z M248,16c79.4,0,144,64.6,144,144c0,31.112-4.336,62.048-12.88,91.96l-0.288,1.016c-3.536-1.872-7.576-2.4-11.472-1.376
			c-4.2,1.096-7.696,3.776-9.848,7.536l-13.536,23.688l-26.4-13.08l38.712-38.704C363.84,223.48,368,213.432,368,202.744V120
			c0-22.056-17.944-40-40-40H168c-22.056,0-40,17.944-40,40v82.744c0,10.688,4.16,20.736,11.712,28.288l38.776,38.776
			l-25.968,12.984l-13.528-23.672c-2.16-3.76-5.656-6.44-9.84-7.528c-4.072-1.056-8.288-0.48-11.928,1.592l-0.352-1.216
			C108.336,222.048,104,191.112,104,160C104,80.6,168.6,16,248,16z M124.968,267.144l56.2,98.024l-26.28,15.768l-56.056-98.112
			L124.968,267.144z M128,480H64V364.232c0-19.552,10.416-37.952,27.192-48.016l6.176-3.704L128,366.128V480z M224,480h-80v-87.44
			c1.92,1.8,4.224,3.168,6.84,3.856c1.352,0.352,2.72,0.528,4.08,0.528c2.856,0,5.672-0.776,8.2-2.288l26.28-15.768
			c7.408-4.456,9.936-14.168,5.656-21.656l-13.248-23.192L200,324.944V328c0,13.232,10.768,24,24,24V480z M216,328v-8h16v-16h-16
			v-16h16v-16h-16v-8c0-4.416,3.592-8,8-8h48c4.408,0,8,3.584,8,8v8h-16v16h16v16h-16v16h16v8c0,4.416-3.592,8-8,8h-48
			C219.592,336,216,332.416,216,328z M352,480h-80v-16h-16v16h-16V352h16v96h16v-96c13.232,0,24-10.768,24-24v-3.144l18.696,9.208
			l-13.24,23.168c-4.296,7.504-1.752,17.208,5.656,21.664l26.28,15.768c2.52,1.512,5.336,2.288,8.192,2.288
			c1.36,0,2.736-0.176,4.088-0.528c2.392-0.624,4.512-1.816,6.328-3.376V480z M432,480h-64V367.024l31.016-54.28l5.792,3.48
			C421.584,326.28,432,344.68,432,364.232V480z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="160" y="112" width="120" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="112" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function HandBurn({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 400 400"
    >
      <g>
        <g>
          <path
            d="M307.713,90.796c-0.514-4.672-1.916-9.062-4.152-13.047c-1.034-1.84-2.218-3.574-3.59-5.207
           c-0.996-1.183-1.95-2.402-3.117-3.457c-1.258-1.25-19.438-19.461-23.877-23.906c-0.461-0.457-0.82-0.82-0.951-0.95
           c-1.908,1.91-3.492,3.492-4.834,4.832c-0.67,0.672-1.279,1.282-1.838,1.84c-5.034,5.031-5.977,5.977-10.302,10.305
           c-0.481,0.481-1.004,1.004-1.578,1.578c-0.862,0.863-1.89,1.89-3.022,3.019c-1.131,1.133-2.362,2.363-3.83,3.832
           c-0.302,0.301-0.512,0.664-0.802,0.977c-2.473,2.652-4.457,5.621-6.006,8.805c-2.346,4.828-3.715,10.098-3.715,15.625
           c-0.002,19.857,16.065,35.931,35.928,35.931c17.358,0,31.43-12.266,35.054-28.246c0.654-2.879,1.082-5.836,1.004-8.914
           C308.06,92.781,307.824,91.808,307.713,90.796z M292.015,96.671c-1.016,9.45-8.705,18.301-19.99,18.301
           c-4.182,0-7.862-1.238-10.906-3.254c-0.67-0.446-1.297-0.934-1.9-1.453c-0.26-0.218-0.545-0.414-0.793-0.649
           c-5.324-5.054-7.645-12.914-5.549-20.149c0.182-0.624,0.41-1.242,0.658-1.854c0.27-0.664,0.553-1.324,0.904-1.969
           c0.897-1.649,2.035-3.234,3.494-4.695l7.043-7.043l7.041-7.039c5.598,5.606,11.939,11.953,13.66,13.652
           c0.246,0.246,0.398,0.394,0.398,0.394c0.142,0.125,0.213,0.23,0.309,0.32c1.065,1.004,1.935,2.094,2.691,3.23
           C291.542,88.175,292.465,92.472,292.015,96.671z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M400,232c0-13.969-9.004-25.718-21.482-30.086C381.978,196.801,384,190.637,384,184c0-17.672-14.326-32-32-32
           c-70.782,0-104.25,0-200.848,0l28.072-28.062c21.522-21.523,23.408-64.785,8.928-79.25C185.25,41.785,181.598,40,178.156,40
           c-2.326,0-4.554,0.817-6.386,2.656L30.371,182.371l0.168,0.019C11.676,201.215,0,227.242,0,256c0,57.438,46.562,104,104,104
           c29.762,0,47.523,0,57.67,0c8.795,0,11.877,0,11.996,0c17.733,0,58.795,0,146.334,0c17.674,0,32-14.328,32-32
           c0-5.859-1.687-11.278-4.438-16H352c17.674,0,32-14.328,32-32c0-6.637-2.022-12.801-5.481-17.914
           C390.996,257.718,400,245.969,400,232z M368,248h-16H208v16h144c8.824,0,16,7.18,16,16c0,8.824-7.176,16-16,16H208v16h112
           c8.824,0,16,7.18,16,16c0,8.824-7.176,16-16,16c-134.625,0-177.473,0-189.332,0c-3.066,0-4.078,0-4.078,0
           c-3.301,0-9.053,0-18.614,0c-48.886,0-91.437-38.129-91.968-87.012c-0.262-23.906,8.938-46.414,25.834-63.27L178.49,58.507
           c1.918,3.938,3.67,11.446,2.76,21.75c-1.152,13.066-6.141,25.164-13.338,32.363l-41.733,41.722
           c-5.039,5.04-1.471,13.657,5.656,13.657c107.4,0,121.557,0,220.164,0c8.824,0,16,7.18,16,16c0,8.824-7.176,16-16,16H208v16h144h16
           c8.824,0,16,7.18,16,16C384,240.824,376.824,248,368,248z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function HexMolecule({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 470 470"
    >
      <g>
        <path d="m250.893,173.727l29.224,16.873c1.181,0.682 2.471,1.006 3.743,1.006 2.592,0 5.113-1.346 6.502-3.751 2.071-3.587 0.842-8.174-2.745-10.245l-29.224-16.873c-3.587-2.072-8.174-0.842-10.245,2.745-2.072,3.587-0.843,8.174 2.745,10.245z" />
        <path d="m166.489,210.628c-4.142,0-7.5,3.358-7.5,7.5v33.745c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-33.745c0-4.142-3.358-7.5-7.5-7.5z" />
        <path d="m280.118,279.4l-29.224,16.873c-3.587,2.071-4.816,6.658-2.745,10.245 1.389,2.406 3.91,3.751 6.502,3.751 1.272,0 2.562-0.324 3.743-1.006l29.224-16.873c3.587-2.071 4.816-6.658 2.745-10.245-2.071-3.587-6.658-4.816-10.245-2.745z" />
        <path d="m432.021,321.25c-7.437,0-14.19,2.973-19.145,7.786l-52.702-30.428c0.545-2.156 0.837-4.411 0.837-6.733 0-12.563-8.472-23.178-20-26.452v-60.846c11.528-3.274 20-13.889 20-26.452 0-2.323-0.292-4.578-0.837-6.734l52.702-30.427c4.955,4.814 11.708,7.786 19.146,7.786 15.164,0 27.5-12.336 27.5-27.5s-12.336-27.5-27.5-27.5-27.5,12.336-27.5,27.5c0,2.323 0.292,4.578 0.837,6.734l-52.702,30.428c-4.955-4.814-11.708-7.786-19.145-7.786-7.437,0-14.19,2.973-19.145,7.786l-52.702-30.427c0.545-2.156 0.837-4.411 0.837-6.733 0-12.563-8.472-23.178-20-26.452v-87.3c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v87.298c-11.528,3.274-20,13.889-20,26.452 0,2.323 0.292,4.578 0.837,6.734l-52.702,30.427c-4.955-4.813-11.708-7.786-19.145-7.786s-14.19,2.973-19.145,7.786l-52.702-30.428c0.545-2.156 0.837-4.411 0.837-6.733 0-15.164-12.336-27.5-27.5-27.5s-27.5,12.336-27.5,27.5 12.336,27.5 27.5,27.5c7.438,0 14.19-2.973 19.146-7.786l52.702,30.428c-0.545,2.156-0.837,4.411-0.837,6.734 0,12.563 8.472,23.178 20,26.452v60.846c-11.528,3.274-20,13.889-20,26.452 0,2.323 0.292,4.578 0.837,6.734l-52.702,30.428c-4.955-4.814-11.708-7.786-19.145-7.786-15.164,0-27.5,12.336-27.5,27.5s12.336,27.5 27.5,27.5 27.5-12.336 27.5-27.5c0-2.323-0.292-4.578-0.837-6.734l52.702-30.428c4.955,4.814 11.708,7.786 19.145,7.786s14.19-2.973 19.145-7.786l52.702,30.427c-0.545,2.156-0.837,4.411-0.837,6.734 0,12.563 8.472,23.178 20,26.452v87.297c0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-87.298c11.528-3.274 20-13.889 20-26.452 0-2.323-0.292-4.578-0.837-6.734l52.702-30.427c4.955,4.814 11.708,7.786 19.145,7.786 7.438,0 14.19-2.973 19.146-7.786l52.702,30.428c-0.545,2.156-0.837,4.411-0.837,6.734 0,15.164 12.336,27.5 27.5,27.5s27.5-12.336 27.5-27.5-12.339-27.501-27.503-27.501zm0-212.5c6.893,0 12.5,5.607 12.5,12.5s-5.607,12.5-12.5,12.5-12.5-5.607-12.5-12.5 5.607-12.5 12.5-12.5zm-394.042,25c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.607,12.5-12.5,12.5zm0,227.5c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.607,12.5-12.5,12.5zm295.531-195.625c6.893,0 12.5,5.607 12.5,12.5s-5.607,12.5-12.5,12.5-12.5-5.607-12.5-12.5 5.608-12.5 12.5-12.5zm-98.51-56.875c6.893,0 12.5,5.607 12.5,12.5s-5.607,12.5-12.5,12.5-12.5-5.607-12.5-12.5 5.607-12.5 12.5-12.5zm-111.01,69.375c0-6.893 5.607-12.5 12.5-12.5s12.5,5.607 12.5,12.5-5.607,12.5-12.5,12.5-12.5-5.607-12.5-12.5zm12.5,126.25c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.608,12.5-12.5,12.5zm98.51,56.875c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.607,12.5-12.5,12.5zm71.01-69.375c0,2.323 0.292,4.578 0.837,6.734l-52.702,30.427c-4.955-4.813-11.708-7.786-19.145-7.786s-14.19,2.973-19.145,7.786l-52.702-30.427c0.545-2.156 0.837-4.411 0.837-6.734 0-12.563-8.472-23.178-20-26.452v-60.846c11.528-3.274 20-13.889 20-26.452 0-2.323-0.292-4.578-0.837-6.734l52.702-30.427c4.955,4.814 11.708,7.786 19.145,7.786 7.438,0 14.19-2.973 19.146-7.786l52.702,30.427c-0.545,2.156-0.837,4.411-0.837,6.734 0,12.563 8.472,23.178 20,26.452v60.846c-11.529,3.274-20.001,13.889-20.001,26.452zm27.5,12.5c-6.893,0-12.5-5.607-12.5-12.5 0-6.891 5.605-12.497 12.495-12.5 6.9,0.003 12.505,5.609 12.505,12.5 0,6.893-5.607,12.5-12.5,12.5zm98.511,56.875c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.607,12.5-12.5,12.5z" />
      </g>
    </svg>
  );
}

export function Briefcase({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      height={height}
      fill={fill}
      className={className}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M469.333,106.667H362.667V85.333c0-23.531-19.135-42.667-42.667-42.667H192c-23.531,0-42.667,19.135-42.667,42.667v21.333
			H42.667C19.135,106.667,0,125.802,0,149.333v277.333c0,23.531,19.135,42.667,42.667,42.667h426.667
			c23.531,0,42.667-19.135,42.667-42.667V149.333C512,125.802,492.865,106.667,469.333,106.667z M170.667,85.333
			C170.667,73.573,180.24,64,192,64h128c11.76,0,21.333,9.573,21.333,21.333v21.333H170.667V85.333z M490.667,426.667
			c0,11.76-9.573,21.333-21.333,21.333H42.667c-11.76,0-21.333-9.573-21.333-21.333V271.4c6.301,3.674,13.527,5.934,21.333,5.934
			h170.667v32c0,5.896,4.771,10.667,10.667,10.667h64c5.896,0,10.667-4.771,10.667-10.667v-32h170.667
			c7.806,0,15.033-2.259,21.333-5.934V426.667z M234.667,298.667V256h42.667v42.667H234.667z M490.667,234.667
			c0,11.76-9.573,21.333-21.333,21.333H298.667v-10.667c0-5.896-4.771-10.667-10.667-10.667h-64
			c-5.896,0-10.667,4.771-10.667,10.667V256H42.667c-11.76,0-21.333-9.573-21.333-21.333v-85.333
			c0-11.76,9.573-21.333,21.333-21.333h426.667c11.76,0,21.333,9.573,21.333,21.333V234.667z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export function Search({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      id="Capa_1"
      viewBox="0 0 512 512"
    >
      <g id="XMLID_34_">
        <g id="XMLID_1873_">
          <path
            id="XMLID_1877_"
            d="m327.651 52.349c-72.785 0-132 59.215-132 132s59.215 132 132 132 132-59.215 132-132c0-72.786-59.214-132-132-132zm0 20c61.757 0 112 50.243 112 112s-50.243 112-112 112-112-50.243-112-112 50.244-112 112-112z"
          />
          <path
            id="XMLID_1878_"
            d="m388.597 123.404c3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142-.001c-12.502-12.501-29.123-19.387-46.803-19.387s-34.302 6.885-46.803 19.387c-1.953 1.953-4.512 2.929-7.071 2.929s-5.119-.977-7.071-2.929c-3.905-3.905-3.906-10.237 0-14.142 16.279-16.28 37.923-25.245 60.946-25.245 23.02.001 44.664 8.966 60.944 25.246z"
          />
          <path
            id="XMLID_1881_"
            d="m0 469.737c0 11.289 4.396 21.902 12.378 29.885 7.983 7.982 18.596 12.378 29.885 12.378s21.902-4.396 29.884-12.379l120.161-120.16c5.516 3.179 11.702 4.776 17.89 4.776 9.17 0 18.34-3.491 25.322-10.472l19.84-19.841c22.209 9.504 46.645 14.774 72.291 14.774 101.65 0 184.349-82.698 184.349-184.349 0-83.633-56.408-156.935-137.175-178.255-5.336-1.41-10.811 1.776-12.221 7.117-1.41 5.34 1.777 10.811 7.117 12.221 71.996 19.005 122.279 84.354 122.279 158.917 0 90.622-73.727 164.349-164.349 164.349s-164.349-73.727-164.349-164.349c0-74.561 50.281-139.909 122.275-158.916 5.34-1.41 8.526-6.882 7.116-12.222s-6.883-8.523-12.222-7.116c-80.764 21.322-137.17 94.623-137.17 178.254 0 25.645 5.27 50.081 14.774 72.291l-19.841 19.84c-11.693 11.693-13.587 29.523-5.697 43.212l-120.159 120.161c-7.982 7.982-12.378 18.595-12.378 29.884zm199.019-110.115-46.641-46.641c-6.165-6.164-6.165-16.195 0-22.359l15.097-15.097c16.403 28.704 40.296 52.597 69 69l-15.097 15.098c-6.165 6.164-16.195 6.164-22.359-.001zm-179.019 110.115c0-5.946 2.316-11.537 6.521-15.742l119.293-119.293 31.484 31.484-119.293 119.293c-4.205 4.205-9.796 6.521-15.742 6.521-5.947 0-11.538-2.316-15.742-6.521-4.205-4.205-6.521-9.795-6.521-15.742z"
          />
          <path
            id="XMLID_1884_"
            d="m327.65 20c-2.63 0-5.211-1.07-7.07-2.93-1.86-1.86-2.93-4.44-2.93-7.07s1.07-5.21 2.93-7.07 4.44-2.93 7.07-2.93 5.21 1.07 7.07 2.93 2.93 4.44 2.93 7.07-1.07 5.21-2.93 7.07-4.44 2.93-7.07 2.93z"
          />
        </g>
      </g>
    </svg>
  );
}
export function Testtube({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 448 448"
    >
      <g>
        <g>
          <path
            d="M331.998,80V46.18l-80-46.18L180,41.562L108,0L28,46.18v92.363l72,41.578v82.582l80,46.195l64-36.957V368
			c0,44.176,35.824,80,80,80c44.176,0,80-35.824,80-80V96h16V80H331.998z M44,129.309v-73.89l64-36.942l64,36.942v73.359
			l-64.47,37.215L44,129.309z M243.998,253.465l-64,36.957L116,253.465v-73.344l64-36.957l63.998,36.957V253.465z M244,161.102
			l-56-32.324V55.418l63.998-36.942l64,36.942V80H228v16h16V161.102z M388,368c0,35.289-28.711,64-64,64c-35.291,0-64-28.711-64-64
			V240h128V368z M388,224H260V96h128V224z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M340,264c-17.674,0-32,14.328-32,32s14.326,32,32,32c17.672,0,32-14.328,32-32S357.672,264,340,264z M340,312
			c-8.822,0-16-7.176-16-16c0-8.82,7.178-16,16-16s16,7.18,16,16C356,304.824,348.822,312,340,312z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M300,336c-13.256,0-24,10.746-24,24s10.744,24,24,24c13.254,0,24-10.746,24-24S313.254,336,300,336z M300,368
			c-4.412,0-8-3.59-8-8s3.588-8,8-8c4.41,0,8,3.59,8,8S304.41,368,300,368z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="284" cy="312" r="8" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="348" cy="392" r="8" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="300" cy="264" r="8" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Injection({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 509.397 509.397"
    >
      <g transform="translate(1 1)">
        <g>
          <g>
            <path
              d="M475.42,51.068l-12.149-12.149l-25.166-25.166L425.956,1.603c-3.471-3.471-8.678-3.471-12.149,0s-3.471,8.678,0,12.149
				l6.136,6.136l-30.925,31.556l-30.75-30.75c-3.471-3.471-8.678-3.471-12.149,0L321.82,44.993
				c-1.736,1.736-2.603,3.471-2.603,6.075s0.868,4.339,2.603,6.075l6.075,6.075L297.522,93.59c-0.147,0.147-0.279,0.301-0.414,0.454
				c-0.153,0.135-0.307,0.266-0.454,0.414l-95.457,95.457c0,0-0.001,0.001-0.001,0.001l-26.902,26.902
				c-3.471,3.471-3.471,8.678,0,12.149l19.091,19.092l-18.224,18.224c-0.147,0.147-0.279,0.301-0.413,0.454
				c-0.153,0.135-0.307,0.267-0.455,0.414l-26.034,26.034c-7.718,7.718-9.189,18.837-4.427,27.858L58.01,406.864
				c-3.471,3.471-3.471,8.678,0,12.149c1.736,1.736,3.471,2.603,6.075,2.603c2.603,0,4.339-0.868,6.075-2.603l85.415-85.415
				c3.764,2.445,8.203,3.843,12.646,3.843c6.075,0,12.149-2.603,16.488-7.81l26.034-26.034c0.165-0.165,0.314-0.337,0.464-0.509
				c0.136-0.118,0.277-0.231,0.404-0.358l18.224-18.224l18.224,18.224c1.736,1.736,3.471,2.603,6.075,2.603
				c2.603,0,4.339-0.868,6.075-2.603l100.664-100.664l21.695-21.695c0.191-0.191,0.368-0.383,0.538-0.576
				c0.11-0.098,0.226-0.188,0.329-0.292l30.373-30.373l6.075,6.075c1.736,1.736,3.471,2.603,6.075,2.603s4.339-0.868,6.075-2.603
				l24.298-24.298c3.471-3.471,3.471-8.678,0-12.149l-30.373-30.373l31.241-31.241l6.075,6.075c1.736,1.736,3.471,2.603,6.075,2.603
				c1.736,0,4.339-0.868,6.075-2.603C478.892,59.746,478.892,54.539,475.42,51.068z M173.427,318.349
				c-2.603,2.603-6.942,2.603-9.546,0l-3.471-3.471c-2.603-1.736-2.603-6.075,0-8.678l19.959-19.959l13.017,12.149L173.427,318.349z
				 M204.668,283.637l-12.149-12.149l12.149-12.149l12.149,12.149L204.668,283.637z M340.044,75.366l12.583,12.583l-24.298,24.298
				l-12.583-12.583L340.044,75.366z M340.478,124.397l23.864-23.864l12.149,12.149l-23.864,23.864L340.478,124.397z
				 M254.132,284.505l-30.496-30.496l-12.026-12.026c0,0,0,0-0.001-0.001l-19.091-19.091l18.224-18.224h123.227L254.132,284.505z
				 M351.325,187.312H228.098l74.631-74.631l61.614,61.614L351.325,187.312z M377.359,161.278l-12.583-12.583l24.298-24.298
				l12.583,12.583L377.359,161.278z M425.956,136.98l-6.075-6.075l-73.763-73.763l-6.075-6.075l12.149-12.149l85.912,85.912
				L425.956,136.98z M413.807,75.366l-12.149-12.149l30.373-30.373l12.149,12.149L413.807,75.366z"
            />
            <path
              d="M68.424,434.634c-3.471-3.471-8.678-3.471-12.149,0L38.919,451.99c-6.075,6.075-9.546,14.753-9.546,23.431
				s3.471,17.356,9.546,23.43s14.753,9.546,23.43,9.546c8.678,0,17.356-3.471,23.431-9.546s9.546-14.753,9.546-23.43
				s-3.471-17.356-9.546-23.431L68.424,434.634z M73.63,486.702c-6.075,6.075-16.488,6.075-22.563,0
				c-2.603-3.471-4.339-6.942-4.339-11.281s1.736-8.678,4.339-11.281l11.281-11.281l11.281,11.281
				c2.603,3.471,4.339,6.942,4.339,11.281S76.234,484.098,73.63,486.702z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function MultipleKeys({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M144,32C82.24,32,32,82.24,32,144s50.24,112,112,112s112-50.24,112-112S205.76,32,144,32z M144,240
			c-52.936,0-96-43.064-96-96c0-52.936,43.064-96,96-96c52.936,0,96,43.064,96,96C240,196.936,196.936,240,144,240z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M110.608,71.28C82.296,84.304,64,112.848,64,144h16c0-24.928,14.64-47.76,37.296-58.176L110.608,71.28z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M126.232,65.984l3.536,15.6C134.408,80.536,139.192,80,144,80V64C138,64,132.024,64.664,126.232,65.984z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M288,144C288,64.6,223.4,0,144,0S0,64.6,0,144c0,65.512,44.016,120.84,104,138.232V304H88v16h16v16H88v16h16v104
			c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40V352h16v-16h-16v-16h16v-16h-16v-21.768C243.984,264.84,288,209.512,288,144z
			 M168,456c0,13.232-10.768,24-24,24s-24-10.768-24-24V352h48V456z M168,336h-48v-16h48V336z M168,304h-48v-18.168
			c7.824,1.32,15.808,2.168,24,2.168s16.176-0.848,24-2.168V304z M144,272c-70.576,0-128-57.424-128-128S73.424,16,144,16
			s128,57.424,128,128S214.576,272,144,272z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M392,227.92V128c13.232,0,24-10.768,24-24s-10.768-24-24-24V32c0-17.648-14.352-32-32-32s-32,14.352-32,32v48
			c-13.232,0-24,10.768-24,24s10.768,24,24,24v99.92C267.376,242.544,224,296.976,224,360c0,74.992,61.008,136,136,136
			s136-61.008,136-136C496,296.976,452.624,242.544,392,227.92z M344,32c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16v48h-32V32z
			 M320,104c0-4.408,3.592-8,8-8h64c4.408,0,8,3.592,8,8s-3.592,8-8,8h-64C323.592,112,320,108.408,320,104z M376,160v16h-16v16h16
			v16h-16v16h16v52.688l-16,16l-16-16V128h32v16h-16v16H376z M360,480c-66.168,0-120-53.832-120-120
			c0-54.312,36.472-101.464,88-115.656v38.968l24,24V328h16v-20.688l24-24v-38.968c51.528,14.192,88,61.344,88,115.656
			C480,426.168,426.168,480,360,480z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M288,304c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S301.232,304,288,304z M288,336c-4.408,0-8-3.592-8-8
			c0-4.408,3.592-8,8-8c4.408,0,8,3.592,8,8C296,332.408,292.408,336,288,336z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M408,400c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S421.232,400,408,400z M408,432c-4.408,0-8-3.592-8-8
			c0-4.408,3.592-8,8-8c4.408,0,8,3.592,8,8C416,428.408,412.408,432,408,432z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M416,312v4c0,6.616-5.384,12-12,12c-15.44,0-28,12.56-28,28v4h16v-4c0-6.616,5.384-12,12-12c15.44,0,28-12.56,28-28v-4
			H416z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M316,400c-6.616,0-12-5.384-12-12v-4h-16v4c0,15.44,12.56,28,28,28c6.616,0,12,5.384,12,12v4h16v-4
			C344,412.56,331.44,400,316,400z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="440" y="352" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="280" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="328" y="368" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="288" y="432" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Golla({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      viewBox="0 0 470 470"
    >
      <g>
        <path d="m168.757,205.591l-7.525-2.445c-3.935-1.28-8.171,0.875-9.45,4.815-1.28,3.939 0.876,8.17 4.815,9.45l7.507,2.439c-1.044,4.889-1.604,9.954-1.604,15.149s0.561,10.261 1.604,15.149l-7.507,2.439c-3.939,1.28-6.096,5.511-4.815,9.45 1.029,3.169 3.97,5.185 7.131,5.185 0.769,0 1.55-0.119 2.319-0.369l7.525-2.445c4.179,9.375 10.278,17.71 17.814,24.488l-4.661,6.416c-2.435,3.351-1.692,8.042 1.659,10.476 1.331,0.967 2.873,1.433 4.402,1.433 2.318,0 4.606-1.072 6.073-3.092l4.657-6.411c8.637,5.018 18.389,8.319 28.798,9.394v7.888c0,4.142 3.357,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-7.887c10.409-1.075 20.161-4.376 28.798-9.394l4.657,6.411c1.467,2.02 3.754,3.092 6.073,3.092 1.528,0 3.071-0.466 4.402-1.433 3.352-2.435 4.094-7.125 1.659-10.476l-4.661-6.416c7.536-6.778 13.635-15.113 17.814-24.488l7.524,2.445c0.77,0.25 1.551,0.369 2.319,0.369 3.161,0 6.102-2.015 7.131-5.184 1.28-3.939-0.876-8.171-4.815-9.451l-7.506-2.439c1.044-4.889 1.604-9.954 1.604-15.15s-0.561-10.261-1.604-15.15l7.506-2.439c3.939-1.28 6.096-5.511 4.815-9.451-1.279-3.94-5.514-6.095-9.45-4.815l-7.524,2.445c-4.179-9.375-10.278-17.71-17.814-24.488l4.661-6.416c2.435-3.351 1.692-8.042-1.659-10.476-3.348-2.434-8.041-1.693-10.476,1.66l-4.657,6.411c-8.637-5.018-18.389-8.319-28.798-9.394v-7.886c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v7.887c-10.409,1.075-20.161,4.376-28.798,9.394l-4.657-6.411c-2.434-3.351-7.124-4.093-10.476-1.66-3.352,2.435-4.094,7.125-1.659,10.476l4.661,6.416c-7.534,6.779-13.633,15.114-17.812,24.489zm66.243-28.091c31.706,0 57.5,25.794 57.5,57.5s-25.794,57.5-57.5,57.5-57.5-25.794-57.5-57.5 25.794-57.5 57.5-57.5z" />
        <path d="M401.17,68.83C356.784,24.444,297.771,0,235,0S113.216,24.444,68.83,68.83S0,172.229,0,235s24.444,121.784,68.83,166.17   S172.229,470,235,470c40.195,0,79.866-10.326,114.725-29.86c3.614-2.025,4.901-6.596,2.877-10.209s-6.595-4.902-10.21-2.876   C309.769,445.336,272.633,455,235,455c-121.309,0-220-98.691-220-220S113.691,15,235,15s220,98.691,220,220   c0,37.63-9.669,74.769-27.961,107.403c-2.025,3.613-0.738,8.184,2.875,10.209c3.611,2.023,8.184,0.739,10.209-2.875   C459.669,314.868,470,275.192,470,235C470,172.229,445.556,113.216,401.17,68.83z" />
        <path d="m395.867,355.867c-22.056,0-40,17.944-40,40s17.944,40 40,40 40-17.944 40-40-17.944-40-40-40zm0,65c-13.785,0-25-11.215-25-25s11.215-25 25-25 25,11.215 25,25-11.215,25-25,25z" />
        <path d="m120.979,349.021c31.437,31.436 72.729,47.154 114.021,47.154s82.585-15.718 114.021-47.154c62.871-62.872 62.871-165.17 0-228.042-45.445-45.445-113.45-59.574-173.251-36-0.956,0.377-1.827,0.949-2.555,1.676-2.929,2.929-2.928,7.677 0.001,10.605 2.221,2.22 5.486,2.757 8.215,1.61 54.205-21.297 115.805-8.464 156.982,32.714 57.023,57.023 57.023,149.806 0,206.829-28.515,28.515-65.958,42.771-103.414,42.767-37.447-0.003-74.906-14.259-103.414-42.767-41.217-41.217-54.03-102.898-32.645-157.141 1.52-3.854-0.373-8.209-4.227-9.729-3.855-1.519-8.21,0.374-9.729,4.227-23.575,59.804-9.447,127.809 35.995,173.251z" />
        <path d="m126.282,86.282c-10.685,0-20.729,4.161-28.283,11.716-7.556,7.555-11.717,17.6-11.717,28.284s4.161,20.729 11.716,28.284c7.555,7.555 17.6,11.716 28.284,11.716s20.729-4.161 28.285-11.716c15.595-15.596 15.595-40.972-0.001-56.568-7.554-7.555-17.599-11.716-28.284-11.716zm17.678,57.678c-4.722,4.722-11,7.323-17.678,7.323s-12.955-2.601-17.678-7.323c-4.722-4.722-7.322-11-7.322-17.678s2.601-12.956 7.323-17.678c4.722-4.722 10.999-7.322 17.677-7.322s12.956,2.601 17.678,7.322c9.747,9.748 9.747,25.608 0,35.356z" />
      </g>
    </svg>
  );
}
export function Magnet({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      viewBox="0 0 470 470"
    >
      <g>
        <path d="M432.5,0h-130c-4.142,0-7.5,3.357-7.5,7.5V265c0,33.084-26.916,60-60,60s-60-26.916-60-60V7.5c0-4.143-3.358-7.5-7.5-7.5   h-130C33.358,0,30,3.357,30,7.5V265c0,113.037,91.962,205,205,205s205-91.963,205-205V7.5C440,3.357,436.642,0,432.5,0z M160,15v75   H45V15H160z M235,455c-104.767,0-190-85.233-190-190V105h115v160c0,41.355,33.645,75,75,75s75-33.645,75-75V105h62.5   c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H310V15h115v75h-22.5c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H425v160   C425,369.767,339.767,455,235,455z" />
        <circle cx="143" cy="386" r="7.5" />
        <circle cx="113" cy="356" r="7.5" />
        <circle cx="387.199" cy="170.676" r="7.5" />
      </g>
    </svg>
  );
}
export function Pencil({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 458.496 458.496"
    >
      <g>
        <g>
          <polygon
            points="96.711,368 85.385,379.311 111.335,405.248 29.96,405.248 29.96,421.248 111.335,421.248 85.385,447.183 
			96.711,458.496 141.96,413.248 		"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M252.693,47.574c-6.453-6.578-13.342-10.326-20.541-10.326h-80v16h54.561c-20.31,26.51-35.158,83.594-38.008,152h15.981
			c4.054-98.522,32.364-152,47.466-152s43.412,53.478,47.466,152h15.981c-1.77-42.468-8.177-80.558-17.621-109.742L403.72,221.248
			H168.152v16h0.134c1.037,75.317,16.472,139.416,38.322,168h-54.457v16h80c7.592,0,14.842-4.173,21.6-11.451l0.063,0.138
			l180.529-180.687L252.693,47.574z M232.152,405.248c-15.898,0-46.397-59.309-47.862-168h95.722
			C278.549,345.939,248.05,405.248,232.152,405.248z M277.976,363.133c10.65-32.8,17.368-76.977,18.041-125.885H403.72
			L277.976,363.133z"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="90.904,184 79.576,195.311 105.528,221.248 24.152,221.248 24.152,237.248 105.528,237.248 79.576,263.183 
			90.904,274.496 136.152,229.248 		"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="90.904,0 79.576,11.311 105.528,37.248 24.152,37.248 24.152,53.248 105.528,53.248 79.576,79.183 90.904,90.496 
			136.152,45.248 		"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Shaker({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      height={height}
      fill={fill}
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M456,354.36V320h-40v-32h64v-48h-25.64L408,39.08V0H296v39.184L264.256,192h-32.512L200,39.184V0H88v39.08L41.64,240H16
			v48h64v32H40v34.36C16.896,361.264,0,382.688,0,408v88h496v-88C496,382.688,479.104,361.264,456,354.36z M376,16h16v16h-16V16z
			 M344,16h16v16h-16V16z M312,16h16v16h-16V16z M310.504,48h83.128l18.464,80H293.888L310.504,48z M283.92,176H384v-16h-96.76
			l3.32-16h125.224l3.696,16H400v16h23.176l14.768,64H336v-48h-55.4L283.92,176z M320,208v32h-16v-32H320z M272,208h16v32h-16V208z
			 M240,208h16v32h-16V208z M168,16h16v16h-16V16z M136,16h16v16h-16V16z M104,16h16v16h-16V16z M80.208,144H96v-16H83.904
			l18.464-80h83.128l16.616,80H112v16h93.432l3.32,16H76.512L80.208,144z M72.824,176H212.08l3.32,16H160v48H58.056L72.824,176z
			 M224,208v32h-16v-32H224z M192,208v32h-16v-32H192z M32,272v-16h5.944H168h160h130.056H464v16H32z M400,288v32h-32v-32H400z
			 M352,288v32H144v-32H352z M128,288v32H96v-32H128z M56,336h384v16H56V336z M192,480H16v-72c0-22.056,17.944-40,40-40h136V480z
			 M400,480H208V368h192V480z M480,480h-64V368h24c22.056,0,40,17.944,40,40V480z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M224,384v48h160v-48H224z M368,416H240v-16h128V416z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M48,400v48h112v-48H48z M80,432H64v-16h16V432z M112,432H96v-16h16V432z M144,432h-16v-16h16V432z" />
        </g>
      </g>
      <g>
        <g>
          <rect x="256" y="448" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="448" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="336" y="448" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Chromosome({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      height={height}
      fill={fill}
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <g>
        <g>
          <path
            d="M253.768,103.736c1.48-4.232,2.232-8.648,2.232-13.128v-2.856C256,65.832,238.168,48,216.248,48
			c-17.88,0-33.648,12.04-38.352,29.288l-37.408,137.168C138.96,220.08,133.824,224,128,224c-5.824,0-10.96-3.92-12.496-9.544
			L78.096,77.288C73.4,60.04,57.632,48,39.752,48C17.832,48,0,65.832,0,87.752v2.856c0,4.488,0.752,8.904,2.224,13.136
			L51.16,243.552C54.376,252.712,56,262.288,56,272c0,9.712-1.624,19.288-4.84,28.456L2.224,440.264
			C0.752,444.496,0,448.912,0,453.392v2.856C0,478.168,17.832,496,39.752,496c17.88,0,33.648-12.04,38.352-29.288l37.408-137.168
			C117.04,323.92,122.176,320,128,320c5.824,0,10.96,3.92,12.496,9.544l37.408,137.168C182.6,483.96,198.368,496,216.248,496
			c21.92,0,39.752-17.832,39.752-39.752v-2.856c0-4.488-0.752-8.904-2.224-13.136L204.84,300.448
			c-3.216-9.16-4.84-18.736-4.84-28.448c0-9.712,1.624-19.288,4.84-28.456L253.768,103.736z M189.744,238.256
			C185.928,249.128,184,260.488,184,272c0,11.512,1.928,22.872,5.736,33.744L203.12,344H184v16h24.72l8.4,24H200v16h22.72l8.4,24
			H216v16h20.72l1.944,5.544c0.888,2.528,1.336,5.168,1.336,7.848v2.856C240,469.344,229.344,480,216.248,480
			c-10.68,0-20.112-7.192-22.912-17.504l-37.408-137.168C152.504,312.776,141.024,304,128,304s-24.504,8.776-27.928,21.336
			l-37.408,137.16C59.856,472.808,50.432,480,39.752,480C26.656,480,16,469.344,16,456.248v-2.856c0-2.68,0.448-5.32,1.336-7.84
			L19.28,440H40v-16H24.88l8.4-24H56v-16H38.872l8.4-24H72v-16H52.872l13.384-38.256C70.072,294.872,72,283.512,72,272
			c0-11.512-1.928-22.872-5.736-33.744L52.88,200H72v-16H47.28l-8.4-24H56v-16H33.28l-8.4-24H40v-16H19.28l-1.944-5.544
			C16.448,95.928,16,93.288,16,90.608v-2.856C16,74.656,26.656,64,39.752,64c10.68,0,20.112,7.192,22.912,17.504l37.408,137.168
			c2.696,9.888,10.416,17.36,19.928,20.112V264h16v-25.216c9.512-2.76,17.232-10.224,19.928-20.112l37.408-137.168
			C196.144,71.192,205.568,64,216.248,64C229.344,64,240,74.656,240,87.752v2.856c0,2.68-0.448,5.32-1.336,7.84L236.72,104H216v16
			h15.12l-8.4,24H200v16h17.128l-8.4,24H184v16h19.128L189.744,238.256z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M496,8V0h-48.304v8c0,20.984-14.064,33.72-43.656,51.92C374.552,41.792,360.304,28.816,360.304,8V0H312v8
			c0,38.704,23.432,63.008,47.08,80.016c-25.272,18.24-47.08,42.28-47.08,79.968c0,38.712,23.392,63.008,47,80.008
			c-24.68,17.68-47,41.456-47,80c0,38.744,23.432,63.048,47.056,80.048C333.792,426.272,312,450.32,312,488v8h48.304v-8
			c0-21,14.08-33.744,43.704-51.96c28.968,17.784,43.688,30.736,43.688,51.96v8H496v-8c0-38.736-23.432-63.04-47.056-80.04
			C474.208,389.728,496,365.68,496,327.992c0-38.736-23.432-63.04-47.056-80.04C474.208,229.72,496,205.672,496,167.984
			c0-38.704-23.432-63.008-47.08-80.016C474.192,69.728,496,45.688,496,8z M328.408,16h16.432
			c3.184,23.416,20.536,38.352,43.752,53.176c-4.992,2.952-10.104,6.016-15.224,9.248C351.248,63.488,331.464,45.304,328.408,16z
			 M479.576,480h-16.432c-3.384-23.968-21.984-39.272-43.736-53.184c5.016-2.96,10.152-6.04,15.304-9.288
			C455.904,431.88,476.408,450.584,479.576,480z M480,327.992c0,44.536-36.496,66.056-71.8,86.864
			c-35.352,20.84-59.552,37.176-63.368,65.144H328.4c4.104-39.184,38.272-59.336,71.392-78.856
			c38.6-22.752,63.896-40.136,63.896-73.152c0-28.672-20.192-45.784-44.28-61.184c5.016-2.96,10.144-6.04,15.288-9.288
			C457.76,273.136,480,293.888,480,327.992z M361.112,336c-0.512-2.552-0.808-5.2-0.808-8.008c0-2.8,0.272-5.448,0.776-7.992h85.808
			c0.512,2.544,0.8,5.192,0.8,7.992c0,2.808-0.272,5.464-0.776,8.008H392v16h47.432c-7.08,9.208-18.8,17.728-35.44,27.96
			c-16.392-10.064-28.064-18.616-35.24-27.96H376v-16H361.112z M368.56,304c7.08-9.216,18.8-17.736,35.448-27.968
			c16.4,10.072,28.072,18.624,35.248,27.968H368.56z M480,167.984c0,44.536-36.496,66.056-71.8,86.864
			c-38.6,22.752-63.896,40.136-63.896,73.144c0,28.688,20.192,45.792,44.28,61.192c-5.016,2.96-10.144,6.04-15.296,9.288
			C350.24,382.856,328,362.096,328,327.992c0-36.248,24.168-56.872,50.104-73.64l29.048-17.656l0.976-0.528
			c31.488-18.984,55.568-36.048,55.568-68.184c0-28.152-18.504-44.744-44.264-61.184c5-2.952,10.12-6.024,15.256-9.264
			C458.736,113.776,480,133.92,480,167.984z M368.552,144c7.072-9.2,18.784-17.712,35.408-27.936
			c16.512,10.152,28.2,18.752,35.272,27.936H432v16h14.912c0.512,2.544,0.784,5.192,0.784,7.984c0,2.808-0.28,5.464-0.792,8.016
			h-85.808c-0.512-2.552-0.792-5.208-0.792-8.016c0-2.8,0.272-5.448,0.776-7.984H416v-16H368.552z M439.24,192
			c-7.088,9.208-18.768,17.8-35.224,27.912c-16.488-10.144-28.16-18.736-35.24-27.912H439.24z M408.2,94.848
			c-38.6,22.752-63.896,40.136-63.896,73.136c0,28.192,18.536,44.792,44.328,61.248l-15.264,9.28
			C350.288,222.896,328,202.128,328,167.984c0-44.52,36.496-66.04,71.8-86.848c35.352-20.84,59.552-37.184,63.368-65.136H479.6
			C475.496,55.176,441.32,75.328,408.2,94.848z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Lab({ fill, height, className }) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
      height={height}
      fill={fill}
      className={className}
    >
      <g>
        <g>
          <rect
            x="24.818"
            y="395.432"
            transform="matrix(0.5898 -0.8076 0.8076 0.5898 -297.6609 220.8902)"
            width="87.548"
            height="16.001"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            x="99.926"
            y="342.098"
            transform="matrix(0.5898 -0.8076 0.8076 0.5898 -238.6194 230.4499)"
            width="15.193"
            height="16.001"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M224,0v217.472c-9.288,3.312-16,12.112-16,22.528s6.712,19.216,16,22.528v47.032c-14.296,5.08-27.288,13.64-37.76,24.696
			l-4.304-5.872C172.824,315.952,168,301.232,168,285.816v-71.288c9.288-3.312,16-12.112,16-22.528c0-13.232-10.768-24-24-24H96
			c-13.232,0-24,10.768-24,24c0,10.416,6.712,19.216,16,22.528v71.288c0,15.424-4.824,30.144-13.936,42.568l-63.6,86.728
			c-5.256,7.176-8.552,14.72-9.792,22.4c-2.376,14.728,1.736,29.6,11.288,40.832C21.52,489.56,35.456,496,50.184,496h154.264
			c7.832,0,15.352-1.72,22.136-4.792C236.216,494.336,246.088,496,256,496c47.472,0,86.904-34.672,94.552-80H496V0H224z M232,232h48
			c4.416,0,8,3.592,8,8s-3.584,8-8,8h-48c-4.416,0-8-3.592-8-8S227.584,232,232,232z M96,184h64c4.416,0,8,3.592,8,8s-3.584,8-8,8
			H96c-4.416,0-8-3.592-8-8S91.584,184,96,184z M236.6,460.76c-5.52,11.688-18.144,19.24-32.144,19.24H50.184
			c-10.04,0-19.528-4.392-26.048-12.04c-6.6-7.76-9.328-17.664-7.672-27.904c0.832-5.168,3.152-10.376,6.896-15.488l63.6-86.72
			C98.112,322.656,104,304.664,104,285.816V216h48v69.816c0,18.848,5.888,36.84,17.032,52.04l64.352,87.736
			C240.832,435.76,242.064,449.232,236.6,460.76z M256,480c-4.184,0-8.368-0.384-12.52-1.064c3.032-3.384,5.624-7.168,7.592-11.336
			c7.968-16.84,6.144-36.568-4.784-51.48l-50.416-68.744c10.168-11.56,23.568-20.104,38.312-24.288l5.816-1.64V264h32v57.448
			l5.824,1.648C312.08,332.808,336,364.424,336,400C336,444.112,300.112,480,256,480z M448,400h-96
			c0-40.648-26.032-77.008-64-90.448V262.52c9.288-3.312,16-12.112,16-22.528c0-13.232-10.768-24-24-24h-8V48h176V400z M480,400h-16
			V32H256v184h-16V16h240V400z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M288,64v48h144V64H288z M416,96H304V80h112V96z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M24,64C10.768,64,0,74.768,0,88s10.768,24,24,24s24-10.768,24-24S37.232,64,24,64z M24,96c-4.416,0-8-3.592-8-8
			s3.584-8,8-8s8,3.592,8,8S28.416,96,24,96z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M144,104c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S157.232,104,144,104z M144,136c-4.416,0-8-3.592-8-8
			s3.584-8,8-8s8,3.592,8,8S148.416,136,144,136z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M128,0c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S141.232,0,128,0z M128,32c-4.416,0-8-3.592-8-8
			s3.584-8,8-8s8,3.592,8,8S132.416,32,128,32z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="416" y="208" width="16" height="48" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M290.552,346.128l-8.64,13.472C295.744,368.472,304,383.576,304,400c0,12.632-4.864,24.56-13.712,33.584l11.424,11.2
			C313.504,432.752,320,416.84,320,400C320,378.112,308.992,357.968,290.552,346.128z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M256,336v16c4.864,0,9.672,0.728,14.288,2.16l4.736-15.28C268.872,336.968,262.48,336,256,336z" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export function Patil({ fill, height, className }) {
  return (
    <svg
      height={height}
      fill={fill}
      className={className}
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 503.088 503.088"
    >
      <g>
        <g>
          <path
            d="M455.088,371.544h20.456c13.232,0,24-10.768,24-24s-10.768-24-24-24h-49.896c1.128-8.056,1.896-16.104,1.896-24
			c0-79.128-52.32-147.808-128-169.168V67.544c17.648,0,32-14.352,32-32s-14.352-32-32-32h-96c-17.648,0-32,14.352-32,32
			s14.352,32,32,32v62.832c-75.68,21.36-128,90.04-128,169.168c0,7.896,0.768,15.944,1.896,24H27.544c-13.232,0-24,10.768-24,24
			s10.768,24,24,24H48l-48,128h49.096l45.296-120.8c29.776,59.216,90.088,96.8,157.152,96.8s127.376-37.584,157.152-96.8
			L454,499.544h49.088L455.088,371.544z M187.544,35.544c0-8.824,7.176-16,16-16h96c8.824,0,16,7.176,16,16s-7.176,16-16,16h-96
			C194.72,51.544,187.544,44.368,187.544,35.544z M283.544,67.544v32.24c-12.76,0.536-23.256,2.192-33.312,3.864
			c-9.792,1.632-19.256,3.128-30.688,3.648V67.544H283.544z M213.44,144.304l6.104-1.488v-19.512
			c12.76-0.536,23.256-2.192,33.312-3.864c9.792-1.632,19.256-3.128,30.688-3.648v27.032l6.104,1.496
			c71.768,17.552,121.896,81.384,121.896,155.224c0,7.88-0.808,15.936-2.04,24H93.584c-1.232-8.064-2.04-16.12-2.04-24
			C91.544,225.704,141.672,161.872,213.44,144.304z M38,483.544H23.088l42-112H80L38,483.544z M251.544,459.544
			c-60.96,0-115.784-34.16-142.856-88H394.4C367.328,425.384,312.504,459.544,251.544,459.544z M27.544,355.544
			c-4.416,0-8-3.592-8-8c0-4.408,3.584-8,8-8h448c4.416,0,8,3.592,8,8c0,4.408-3.584,8-8,8H27.544z M423.096,371.544h14.912
			l41.992,112h-14.904L423.096,371.544z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="387.544" y="19.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="387.544" y="51.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="403.544" y="35.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="371.544" y="35.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="83.544" y="115.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="83.544" y="147.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="99.544" y="131.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="67.544" y="131.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M131.544,11.544c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S144.776,11.544,131.544,11.544z
			 M131.544,43.544c-4.416,0-8-3.592-8-8s3.584-8,8-8c4.416,0,8,3.592,8,8S135.96,43.544,131.544,43.544z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M299.56,165.888c-15.224-13.64-35.68-20.144-56.184-17.896c-32.36,3.584-58.936,29.6-63.184,61.864
			c-2.592,19.696,2.984,39.512,15.36,54.84v18.848c0,13.232,10.768,24,24,24h64c13.232,0,24-10.768,24-24v-18.84
			c10.344-12.8,16-28.712,16-45.16C323.544,199.096,314.8,179.544,299.56,165.888z M293.544,256.488l-2,2.272v24.784
			c0,4.408-3.584,8-8,8h-8v-16h-16v16h-16v-16h-16v16h-8c-4.416,0-8-3.592-8-8V258.76l-2-2.272
			c-10.856-12.336-15.656-28.152-13.504-44.536c3.304-25.064,23.952-45.272,49.088-48.048c2.184-0.248,4.336-0.36,6.488-0.36
			c13.824,0,26.864,4.952,37.272,14.272c11.856,10.616,18.656,25.824,18.656,41.728C307.544,233.12,302.568,246.24,293.544,256.488z
			"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="339.544" y="91.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="219.544" y="211.544" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="267.544" y="211.544" width="16" height="16" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
